"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _activation = _interopRequireDefault(require("./activation.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData,
      isCsv = _ref.isCsv;
    if (isCsv) {
      return value;
    }
    return /*#__PURE__*/_react["default"].createElement(_activation["default"], {
      row: row,
      loadData: loadData,
      settings: settings
    });
  };
};